module.exports = __webpack_public_path__ + "static/media/pic1.fd292877.jpg";